module.exports = __webpack_public_path__ + "static/media/truck-inventory.6180ee13.svg";